import Base from './base'

export default class Activities extends Base {
  allForUserId(userId) {
    return this.api.get(`people/${userId}/activities.json`)
  }

  success(userId) {
    return this.api.post(`people/${userId}/successes.json`)
  }
}
